import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ListTabConfigurationEntity } from './list-tab-configuration.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index('idx_tab_config_role_unique', ['fkTabConfigurationId', 'fkRbacRoleId'], {
	unique: true,
})
@Index('idx_tab_config_role_config', ['fkTabConfigurationId'])
@Index('idx_tab_config_role_role', ['fkRbacRoleId'])
@Entity('list_tab_configuration_role')
export class ListTabConfigurationRoleEntity extends BaseEntity {
	@Column('int', { name: '_fk_tab_configuration__id', unsigned: true })
	public fkTabConfigurationId!: number;

	@Column('int', { name: '_fk_rbac_role__id', unsigned: true })
	public fkRbacRoleId!: number;

	@ManyToOne(() => ListTabConfigurationEntity, (config) => config.sharedRoles, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([
		{ name: '_fk_tab_configuration__id', referencedColumnName: 'id' },
	])
	public fkTabConfiguration!: ListTabConfigurationEntity;

	@ManyToOne(() => RbacRoleEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_rbac_role__id', referencedColumnName: 'id' }])
	public fkRbacRole!: RbacRoleEntity;
}
